module.exports = "/_next/static/images/03a9bc20e58a9927e5965ef0baa103df-digital-account-phone-main-screen@sm-2x.png";